import React from 'react';
import {Button, Icon} from "semantic-ui-react";
import { handleLogout } from "../../../helpers/logoutHandler";
import {useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import LoggingMenu from "../../../pages/Logging/components/LoggingMenu/LoggingMenu";
import "./MainTopButtons.scss"

const MainTopButtons: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const pages = useAppSelector(state => state.Auth.pages);
    const userName = useAppSelector(state => state.Auth.user?.name || '');
    return (
        <div className="schedule__top-menu">
            <div className="schedule__username-block">{userName}</div>
            { pages['statistics'] &&
                <Button className={'cms-btn'} id="statistic" secondary onClick={() => navigate("/statistics")}>
                    <Icon style={{fontSize: "20px"}} name="chart bar"/>
                </Button>
            }
            { pages['cms'] &&
                <Button className={'cms-btn'} id="cms" secondary onClick={() => navigate("/cms")}>
                    <Icon style={{fontSize: "16px"}} name="cogs"/>
                </Button>
            }
            { pages['logging'] &&
                <Button id="logging" className={"loggingBtn"} secondary>
                    <Icon style={{fontSize: "16px"}} name="info"/>
                    {<LoggingMenu/>}
                </Button>
            }
            <Button id="logout" secondary onClick={() => handleLogout(dispatch, navigate)}>
                Logout
            </Button>
        </div>
    );
};

export default MainTopButtons;
